import { Component, ElementRef, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, of } from 'rxjs';
import { CommonModule } from '@angular/common';
import { AuthHeaderComponent } from '../../global/auth-header/auth-header.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-payment-details',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    AuthHeaderComponent,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
  ],
  templateUrl: './payment-details.component.html',
  styleUrls: ['./payment-details.component.css'],
})
export class PaymentDetailsComponent {
  paymentdetails: FormGroup;
  isCheck = false;
  private apiUrl = 'http://3.81.26.86/api/userOrganizationRegister';
  // static data for states/province
  states: string[] = [
    'Alabama',
    'Alaska',
    'Arizona',
    'Arkansas',
    'California',
    'Colorado',
    'Connecticut',
    'Delaware',
    'Florida',
    'Georgia',
    'Hawaii',
    'Idaho',
    'Illinois',
    'Indiana',
    'Iowa',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Maine',
    'Maryland',
    'Massachusetts',
    'Michigan',
    'Minnesota',
    'Mississippi',
    'Missouri',
    'Montana',
    'Nebraska',
    'Nevada',
    'New Hampshire',
    'New Jersey',
    'New Mexico',
    'New York',
    'North Carolina',
    'North Dakota',
    'Ohio',
    'Oklahoma',
    'Oregon',
    'Pennsylvania',
    'Rhode Island',
    'South Carolina',
    'South Dakota',
    'Tennessee',
    'Texas',
    'Utah',
    'Vermont',
    'Virginia',
    'Washington',
    'West Virginia',
    'Wisconsin',
    'Wyoming',
  ];
  countries: string[] = [
    'United States',
    'Canada',
    'United Kingdom',
    'Germany',
    'France',
    'Australia',
    'Japan',
    'India',
    'China',
    'Brazil',
  ];

  @ViewChild('fileInput') fileInput!: ElementRef; // For file input reference
  imageUrl: string | ArrayBuffer | null = null; // Holds the uploaded image URL

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private router: Router
  ) {
    this.paymentdetails = this.fb.group({
      address: ['', Validators.required],
      org_name: ['', Validators.required],
      org_email: ['', [Validators.required, Validators.email]],
      CardHolderName: ['', Validators.required],
      CardNumber: [
        '',
        [
          Validators.required,
          Validators.minLength(16),
          Validators.maxLength(16),
        ],
      ],
      CardExpiry: ['', Validators.required],
      CVC: [
        '',
        [Validators.required, Validators.minLength(3), Validators.maxLength(4)],
      ],
      AddressLine1: ['', Validators.required],
      AddressLine2: [''],
      country: ['', Validators.required],
      StateProvince: ['', Validators.required],
      city: ['', Validators.required],
      // country: ['', Validators.required],
    });
  }

  onSubmit() {
    if (this.paymentdetails.valid) {
      const formData = this.paymentdetails.value;

      const input = this.fileInput.nativeElement as HTMLInputElement;
      if (input.files && input.files[0]) {
        formData.append('organizationLogo', input.files[0]);
      }

      this.http
        .post(this.apiUrl, formData)
        .pipe(
          catchError((error) => {
            console.error('Error occurred during registration:', error);
            return of(null);
          })
        )
        .subscribe((response) => {
          console.log('Registration successful:', response);
          this.router.navigate(['/login']);
        });
    } else {
      this.paymentdetails.markAllAsTouched();
      console.log('Form is invalid');
    }
  }

  triggerFileInput(): void {
    this.fileInput.nativeElement.click();
  }
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];
      const reader = new FileReader();

      reader.onload = () => {
        this.imageUrl = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  setIsCheck(value: boolean) {
    this.isCheck = value;
  }
  register() {
    this.router.navigate(['/register']);
  }
  back() {
    this.router.navigate(['/paymentplan']);
  }
  navigateToVerification() {
    this.router.navigate(['/verification']);
  }
  navigateToDashboard() {
    this.onSubmit();
    this.router.navigate(['/login']);
  }
}
